import { appEvents } from "@cayo/shared/components/App/appEvents";
import { IPropertiesPanel } from "@cayo/shared/components/AppRoots/PropertiesPanelHolder/types";
import { IActionHandlerParams } from "../types";

export const showNew = (actionId: string, parameters?: IActionHandlerParams) => {
  appEvents.trigger({
    showControl: {
      controlId: "scheme",
      parameters: {
        id: actionId,
        parentId: parameters?.parentId,
        isNewObject: true,
      } as IPropertiesPanel,
    },
  });
};
